import axios from "axios"

export const login = (data: LoginInput) => axios.post("/api/auth/login", data)

export const register = (data: RegisterInput) =>
  axios
    .post("/api/profile/me", data, {
      headers: { "content-type": "multipart/form-data" },
    })
    .then(() =>
      login({ email: data.get("email"), password: data.get("password") })
    )

export const forgot = (data: ForgotInput) =>
  axios.post("/forgot-password", data)

export const reset = (data: ResetInput) => axios.post("/reset-password", data)

export const getProfile = () => axios.get("/api/profile/me")
